// Country name → ISO 3166-1 alpha-2 code mapping for flag rendering.
const COUNTRY_MAP = {
  "United States": "us",
  "Iraq": "iq",
  "United Arab Emirates": "ae",
  "Greece": "gr",
  "Afghanistan": "af",
  "Djibouti": "dj",
  "Japan": "jp",
  "Cyprus": "cy",
  "Moon": null,
  "International Waters": null,
};

export function countryCode(name) {
  return COUNTRY_MAP[name] ?? null;
}

export function flagUrl(name, size = 20) {
  const code = countryCode(name);
  if (!code) return null;
  return `https://flagcdn.com/w${size}/${code}.png`;
}

export function Flag({ country, size = 20, className = "" }) {
  const url = flagUrl(country, size);
  if (!url) {
    // non-terrestrial / open ocean
    const fallback = country === "Moon" ? "◐" : "≋";
    return (
      <span
        className={`inline-flex items-center justify-center w-4 h-3 text-[10px] text-zinc-500 font-mono ${className}`}
        title={country}
      >
        {fallback}
      </span>
    );
  }
  return (
    <img
      src={url}
      alt={country}
      title={country}
      className={`inline-block w-4 h-3 object-cover border border-zinc-800 ${className}`}
      loading="lazy"
    />
  );
}
